module.exports = __webpack_public_path__ + "static/img/p6.2a53a23.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/p6.png
// module id = xk19
// module chunks = 1